import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpService } from 'src/app/https.service';
import { URLUtils } from 'src/app/urlUtils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-view-document-modal',
    templateUrl: './view-document-modal.component.html',
    styleUrls: ['./view-document-modal.component.css'],
    standalone: false
})
export class ViewDocumentModalComponent {
  @Input() document: any;
  @Input() lead: any;
  pdfSrc: SafeResourceUrl | null = null;
  docapi = environment.doc2pdf;
  allowedFileTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/rtf','text/csv','text/rtf'];

  constructor(private sanitizer: DomSanitizer, private toast:ToastrService, private spinnerService:NgxSpinnerService, private httpService: HttpService,public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.document) {
      this.loadDocument();
    }
    console.log('leads',this.lead)
    console.log('leadDoc',this.document)
    // if (this.lead.id || this.lead.docid) {
    //   this.httpService.sendGetRequest(URLUtils.viewDocument(this.lead.id || this.lead.docid)).subscribe((res: any) => {
    //     const url = res?.data?.url;
    //     if (url) {
    //       this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    //     }
    //   });
    // }

    // added doc2pdf
    // this.httpService.sendGetRequest(URLUtils.viewDocument(this.lead.docid || this.lead.id)).subscribe((res: any) => {
    //   if (this.allowedFileTypes.includes(this.lead.content_type || this.lead.contentType)) {
    //     this.spinnerService.show()
    //     this.httpService.sendPostDocRequest(this.docapi, { 'url': res.data.url }).subscribe((ans: any) => {
    //       const blob = new Blob([ans], { type: 'application/pdf' });
    //       // Create a URL for the Blob
    //       const url = URL.createObjectURL(blob);
    //       this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url)
    //       let obj = {
    //         'isIframe': true,
    //         'url': this.pdfSrc
    //       }
    //       this.spinnerService.hide()
    //     })
    //   }
    //   else {
    //     if (res && res.data && !res.error) {
    //       this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
    //       let obj = {
    //         'isIframe': true,
    //         'url': this.pdfSrc
    //       }
    //     }
    //     else {
    //       //alert(res.msg)
    //     }
    //   }
    // });
  }

  loadDocument() {
     console.log('loadDocument called with document:', this.document);
    // console.log('loadDocument called with lead:', this.lead);

    this.pdfSrc = ''

    if (this.document.added_encryption === true) {
      console.log('Document has encryption, decrypting...');
      var body = new FormData();
      // body.append('docid', this.document.id)
      body.append('docid', this.document.docid || this.document.id)
      let url = environment.apiUrl + URLUtils.decryptFile
      this.httpService.sendPostDecryptRequest(url, body).subscribe((res: any) => {
        console.log('response:', res);
        const blob = new Blob([res], { type: this.document.content_type || this.document.contentType });
        const url = URL.createObjectURL(blob);
        if (this.allowedFileTypes.includes(this.document.content_type || this.document.contentType)) {
          this.spinnerService.show()
          let fdata = new FormData();
          fdata.append('file', blob);
          this.httpService.sendPostDecryptRequest(environment.DOC2FILE, fdata).subscribe((ans: any) => {
            const ansBlob = new Blob([ans], { type: 'application/pdf' });
            const ansUrl = URL.createObjectURL(ansBlob);
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl)
            this.spinnerService.hide()
          })

        } else {
          this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url)
          this.spinnerService.hide()
        }
        this.spinnerService.hide()
        //console.log(this.pdfSrc)
      }, (error) => {
        this.spinnerService.hide();
        if (error.status === 500) {
          this.toast.error('Server Error. Please try again later.', 'Error');
        } else {
          this.toast.error('Failed to load the document.', 'Error');
        }
        this.activeModal.dismiss();
      })
      this.spinnerService.hide()
    }
    else if (this.document.added_encryption === false) {
      console.log('Document does not encryption, loading directly...');
      let id = { 'id': this.document.docid || this.document.id }

      this.httpService.sendGetRequest(URLUtils.viewDocuments(id)).subscribe((res: any) => {
        if (this.allowedFileTypes.includes(this.document.content_type || this.document.contentType)) {
          this.spinnerService.show()
          this.httpService.sendPostDocRequest(this.docapi, { 'url': res.data.url }).subscribe((ans: any) => {
            const blob = new Blob([ans], { type: 'application/pdf' });
            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url)
            let obj = {
              'isIframe': true,
              'url': this.pdfSrc
            }

            this.spinnerService.hide()
          }, (error) => {
            this.spinnerService.hide();
            if (error.status === 500) {
              this.toast.error('Server Error. Please try again later.', 'Error');
            } else {
              this.toast.error('Failed to load the document.', 'Error');
            }
            this.activeModal.dismiss();
          })
        }
        else {
          if (res && res.data && !res.error) {
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
            let obj = {
              'isIframe': true,
              'url': this.pdfSrc
            }
            // this.confirmationDialogService.confirm('View', obj, true, "Ok", "Close", false, "lg");
          }
          else {
            alert(res.msg)
          }
        }
        //console.log(" this.view    " + JSON.stringify(this.documents));
      });
    }
    else {
      let id = { 'id': this.document.docid || this.document.id };
      this.spinnerService.show();

      this.httpService.sendGetRequest(URLUtils.viewDocuments(id)).subscribe((res: any) => {
        const fileUrl = res.data.url; // Directly use the pre-signed PDF URL
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl); // Sanitize it for iframe

        const obj = {
          isIframe: true,
          url: this.pdfSrc
        };
        this.spinnerService.hide();
      });
    }
  }

}
